<app-tab-group
        tabGroupClass="suif-tabs-workflow suif-tabs-verty"
        [(selectedIndex)]="currentStepIndex"
>
    <app-tab label="Secure Your Account">
        <ng-container>
            <h1 class="suif-h3">Secure Your Account</h1>

            <div class="suif-body-copy">
                In order to improve the security of your account, we've added new ways to recover your account in case you lose access to your email or
                forget your password.
            </div>

            <div class="suif-body-copy">This process should only take a few moments.</div>

            <div class="button-row">
                <button type="button"
                        class="btn btn-verty"
                        (click)="next()">Get Started
                </button>
            </div>
        </ng-container>
    </app-tab>

    <app-tab label="Recovery Email"
             *ngIf="showBackupEmail">
        <app-account-backup-email
                [primaryEmail]="primaryEmail"
                [userId]="userId"
                [workflow]="true"
                (close)="handleCloseEvent($event)"
                (complete)="next()"
        ></app-account-backup-email>
    </app-tab>

    <app-tab label="Security Questions"
             *ngIf="showSecurityQuestions">
        <app-account-security-questions
                [userId]="userId"
                [workflow]="true"
                (back)="previous()"
                (questionsAnswered)="onAccountSecurityQuestionsSubmitted()"
        ></app-account-security-questions>
    </app-tab>
</app-tab-group>
